import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';

function Header() {
  const [trainingMenuAnchor, setTrainingMenuAnchor] = React.useState(null);
  const [communityMenuAnchor, setCommunityMenuAnchor] = React.useState(null);
  const [mobileMenuAnchor, setMobileMenuAnchor] = React.useState(null);
  const [mobileTrainingMenuAnchor, setMobileTrainingMenuAnchor] = React.useState(null);
  const [mobileCommunityMenuAnchor, setMobileCommunityMenuAnchor] = React.useState(null);

  const handleOpenMenu = (setAnchor) => (event) => {
    setAnchor(event.currentTarget);
  };

  const handleCloseMenu = (setAnchor) => () => {
    setAnchor(null);
  };

  return (
    <AppBar
      position="sticky"
      elevation={2}
      sx={{
        bgcolor: '#141414',
        color: 'white',
        boxShadow: 'none',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          {/* Logo Text */}
          <Box
            component="a"
            href="/"
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: 'white',
              fontSize: '1.5rem',
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            CloudSec Network
          </Box>

          {/* Desktop Navigation */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', ml: 'auto' }}>
            {/* Training Dropdown */}
            <Button
              sx={{ mx: 1, display: 'flex', alignItems: 'center', color: 'white' }}
              onClick={handleOpenMenu(setTrainingMenuAnchor)}
            >
              Training <ArrowDropDownIcon sx={{ ml: 0.5 }} />
            </Button>
            <Menu
              anchorEl={trainingMenuAnchor}
              open={Boolean(trainingMenuAnchor)}
              onClose={handleCloseMenu(setTrainingMenuAnchor)}
              PaperProps={{
                sx: { bgcolor: 'black', color: 'white' },
              }}
            >
              <MenuItem onClick={handleCloseMenu(setTrainingMenuAnchor)} href="/training#hands-on" component="a">
                Hands-On Learning
              </MenuItem>
              <MenuItem onClick={handleCloseMenu(setTrainingMenuAnchor)} href="/training#awareness" component="a">
                Cybersecurity Awareness
              </MenuItem>
              <MenuItem onClick={handleCloseMenu(setTrainingMenuAnchor)} href="/training#simulation" component="a">
                Simulation Platform
              </MenuItem>
            </Menu>

            {/* Community Dropdown */}
            <Button
              sx={{ mx: 1, display: 'flex', alignItems: 'center', color: 'white' }}
              onClick={handleOpenMenu(setCommunityMenuAnchor)}
            >
              Community <ArrowDropDownIcon sx={{ ml: 0.5 }} />
            </Button>
            <Menu
              anchorEl={communityMenuAnchor}
              open={Boolean(communityMenuAnchor)}
              onClose={handleCloseMenu(setCommunityMenuAnchor)}
              PaperProps={{
                sx: { bgcolor: 'black', color: 'white' },
              }}
            >
              <MenuItem onClick={handleCloseMenu(setCommunityMenuAnchor)} href="/cloudathon" component="a">
                Cloudathon
              </MenuItem>
              <MenuItem onClick={handleCloseMenu(setCommunityMenuAnchor)} href="/community#mentorship" component="a">
                Mentorship Program
              </MenuItem>
              <MenuItem onClick={handleCloseMenu(setCommunityMenuAnchor)} href="/community#spotlight" component="a">
                Spotlight
              </MenuItem>
            </Menu>

            <Button href="https://learn.cloudsecnetwork.com" target="_blank" sx={{ mx: 1, color: 'white' }}>LMS</Button>
            <Button href="https://blog.cloudsecnetwork.com" target="_blank" sx={{ mx: 1, color: 'white' }}>Blog</Button>

            {/* Social Media Icons */}
            <IconButton href="https://www.youtube.com/@cloudsecnetwork" target="_blank" sx={{ mx: 0.5, color: 'white' }}>
              <YouTubeIcon />
            </IconButton>
            <IconButton href="https://linkedin.com/company/cloudsecnetwork" target="_blank" sx={{ mx: 0.5, color: 'white' }}>
              <LinkedInIcon />
            </IconButton>
            <IconButton href="https://x.com/cloudsecnetwork" target="_blank" sx={{ mx: 0.5, color: 'white' }}>
              <TwitterIcon />
            </IconButton>
          </Box>

          {/* Mobile Navigation */}
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenMenu(setMobileMenuAnchor)}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={mobileMenuAnchor}
              open={Boolean(mobileMenuAnchor)}
              onClose={handleCloseMenu(setMobileMenuAnchor)}
              PaperProps={{
                sx: {
                  bgcolor: 'black',
                  color: 'white',
                  width: '100vw',
                  left: 0,
                  right: 0,
                  position: 'absolute',
                },
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <MenuItem onClick={handleCloseMenu(setMobileMenuAnchor)} href="/training" component="a">
                Training
              </MenuItem>
              <MenuItem onClick={handleCloseMenu(setMobileMenuAnchor)} href="/community" component="a">
                Community
              </MenuItem>
              <MenuItem onClick={handleCloseMenu(setMobileMenuAnchor)} href="https://blog.cloudsecnetwork.com" target="_blank" component="a">
                Blog
              </MenuItem>
              <MenuItem onClick={handleCloseMenu(setMobileMenuAnchor)} href="https://learn.cloudsecnetwork.com" target="_blank" component="a">
                LMS
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
